import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import UserContext from '../contexts/userContext'
import { db, auth } from '../utils/firebase'

function Auth({ children }) {
    const [user, setUser] = useState(null)
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [localAuthChecked, setLocalAuthChecked] = useState(false)
    const history = useHistory()

    useEffect(() => {
        const currentUser = auth().currentUser

        if (currentUser) {
            setUser(currentUser)
        }

        auth().onAuthStateChanged(async (user) => {
            if (user) {
                const role = await getRole(user.uid)

                if (role !== 'admin' && role !== 'streamer') {
                    handleLogout()
                } else {
                    user.role = role
                    handleAuth(user)
                }
            } else {
                if (currentUser !== null) {
                    setUser(null)
                }
            }

            setLocalAuthChecked(true)
        })
    }, [])

    const getRole = (uid) => {
        try {
            return db
                .collection('roles')
                .doc(uid)
                .get()
                .then((doc) => {
                    const role = doc.data().role

                    return role
                })
                .catch((error) => null)
        } catch (error) {
            return null
        }
    }

    const handleAuth = (user) => {
        setUser(user)
        setIsAuthenticated(true)
    }

    const handleLogout = () => {
        auth().signOut()

        setUser(null)
        setIsAuthenticated(false)
        history.push('/login')
    }

    const signIn = (emailAddress, password) => {
        return new Promise(async (resolve, reject) => {
            if (!emailAddress || !password) {
                reject()

                return
            }

            if (auth().currentUser) {
                reject()

                return
            }

            await auth()
                .setPersistence(auth.Auth.Persistence.LOCAL)
                .then(() =>
                    auth()
                        .signInWithEmailAndPassword(emailAddress, password)
                        .then(async (value) => {
                            const user = value.user

                            const uid = user.uid

                            if (!uid) {
                                handleLogout()
                                reject()
                            }

                            const role = await getRole(user.uid)

                            if (role !== 'admin' && role !== 'streamer') {
                                handleLogout()
                                reject({ message: 'Нет прав на вход' })
                            }

                            resolve(user)
                        })
                        .catch((reason) => {
                            reject(reason)
                        })
                )
        })
    }

    return (
        <UserContext.Provider
            value={{
                user,
                isAuthenticated,
                localAuthChecked,
                setLocalAuthChecked,
                handleAuth,
                handleLogout,
                signIn,
            }}
        >
            {children}
        </UserContext.Provider>
    )
}

export default Auth
